// Preloader.js
import React from "react";
import './preloader.css';

const Preloader = ({ showWelcome, showLoader }) => {
    return (
        <div className="preloader">
            {showLoader && <div className="loader">
                <div></div>
                <div></div>
                <div></div>
            </div>}
            {showWelcome && <h1>Welcome</h1>}
        </div>
    );
};

export default Preloader;



